require('./bootstrap-setup');
import AOS from 'aos';
import axios from 'axios';
import CookieNotification from 'bb-cookie-notification';

require('./filter');
require('./rental');
require('./trailer-gallery');

AOS.init();

new CookieNotification();

// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

const submitForm = (gRecaptchaResponse) => {
    const form = document.getElementById('form');

    const submitButton = form.querySelector('[type="submit"]');
    submitButton.classList.add('disabled');
    submitButton.disabled = true;
    submitButton.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"></div>';

    const formData = new FormData(form);

    const validationAlert = document.getElementById('form-validation');
    validationAlert.classList.add('hidden');
    validationAlert.classList.remove('alert-danger');

    document.querySelectorAll('.invalid-feedback').forEach((element) => {
        if (!element.classList.contains('d-none')) {
            element.classList.add('d-none');
        }
    });

    document.querySelectorAll('.is-invalid').forEach((element) => {
        element.classList.remove('is-invalid');
    });

    axios.post(window.location.href, formData).then((response) => {
        if (response.data.success) {
            validationAlert.innerHTML = response.data.message;
            validationAlert.classList.add('alert-success');
            validationAlert.classList.remove('d-none');

            form.innerHTML = '';
        }
    }).catch((exception) => {
        if (exception.response.data.errors) {
            for (let error in exception.response.data.errors) {
                const el = form.querySelector('[name="' + error + '"]') || form.querySelector('#' + error);
                el.classList.add('is-invalid');
                if (el.parentNode.querySelector('.d-none') !== null) {
                    el.parentNode.querySelector('.d-none').classList.remove('d-none');
                }
            }
        }

        submitButton.classList.remove('disabled');
        submitButton.disabled = false;
        submitButton.innerHTML = 'Verstuur';
    });
}

window.submitForm = submitForm;

// Add and remove class on scroll
if (document.querySelector('nav')) {
    let scrollpos = window.scrollY
    const header = document.querySelector("nav")
    const headerHeight = header.offsetHeight

    const addClassOnScroll = () => header.classList.add("navbar-shrink")
    const removeClassOnScroll = () => header.classList.remove("navbar-shrink")

    window.addEventListener('scroll', function() {
        scrollpos = window.scrollY;

        if (scrollpos >= headerHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }
    });
}

// Smooth scroll
if (document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const href = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        });
    });
}

if (document.querySelector('.to-top')) {
    document.querySelector('.to-top').addEventListener('click', (e) => {
        e.preventDefault();
        scroll({
            top: 0,
            behavior: 'smooth'
        })
    });
}

// Parallax
if (document.querySelector('#parallax')) {
    document.addEventListener("mousemove", parallax);
    const elem = document.querySelector("#parallax");

    function parallax(e) {
        let _w = window.innerWidth / 2;
        let _h = window.innerHeight / 2;
        let _mouseX = e.clientX;
        let _mouseY = e.clientY;
        let _depth = `${50 - (_mouseX - _w) * 0.01}% ${50 - (_mouseY - _h) * 0.01}%`;
        let x = `${_depth}`;
        elem.style.backgroundPosition = x;
    }
}

// truck-icon move on intersection
const target = document.querySelector('.icon-trigger');
const icon = document.querySelector('.truck-icon');

if (target && icon) {
    function handleIntersection(entries) {

        entries.map((entry) => {
            if (entry.isIntersecting) {
                icon.style.left = "-30px";
            }
        });
    }

    const observer = new IntersectionObserver(handleIntersection, {
        threshold: [0.7]
    });

    observer.observe(target);
}